<template>
  <div>
    <div class="admin_title">试卷回答一览</div>
    <!--右侧内容-->
    <div class="gj_top_class">
      <input name="" type="button" class="btn_s_gj" @click="searchByFilter(filter)"/><input name="" type="text" class="put_gj" v-model="filter.title" @keyup.13="searchByFilter(filter)"/>
      <select name="largeType" v-model="filter.largeType" @change="searchByFilter(filter)">
        <option value="">全部(大分类)</option>
        <option v-for='item in Dropdown.state.largeType' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <select name="middleType" v-model="filter.middleType" @change="searchByFilter(filter)">
        <option value="">全部(中分类)</option>
        <option v-for='item in Dropdown.state.middleType' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <select name="level" v-model="filter.level" @change="searchByFilter(filter)">
        <option value="">全部(等级)</option>
        <option v-for='item in Dropdown.state.level' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
    </div>
    <div class="add_shijuan_con">
      <table id="customers">
        <tr>
          <th width="25%">试卷名称</th>
          <th width="15%">试题类型</th>
          <th width="15%">难易度</th>
          <th width="20%">总分</th>
          <th width="25%">操作</th>
        </tr>
        <tr v-for="item in list" :key="item.id">
          <td>{{item.title}}</td>
          <td>{{item.largeTypeLabel}}-{{item.middleTypeLabel}}</td>
          <td>{{item.levelLabel}}</td>
          <td>{{item.score}}</td>
          <td>
            <a href="javascript:;" class="red_font_a" @@click="examPaperAnswer(item.id)">成绩回答一览</a>
          </td>
        </tr>
      </table>
    </div>
    <!--/右侧内容-->
    <div class="zy_list_bottom">
      <dl>
        <dt><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{courseCnt}}个课程</dt>
        <dd>
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>

import Dropdown from '@/store/modules/dropdowns'
import Paginate from 'vuejs-paginate'
export default {
  components: { Paginate },
  data () {
    return {
      Dropdown: Dropdown,
      filter: {
        pageNo: 1,
        pageSize: this.$global.paginationOptions.page_num,
        largeType: '',
        level: '',
        middleType: '',
        title: '',
        type: ''
      },
      list: [],
      pages: 0,
      courseCnt: 0
    }
  },
  created () {
    this.getExamPapers(this.filter)
  },
  mounted () {
    this.$nextTick(() => {})
  },
  computed: {},
  methods: {
    clickCallback (pageNum) {
      this.filter.pageNo = pageNum
      this.getExamPapers(this.filter)
    },
    searchByFilter (filter) {
      this.getExamPapers(filter)
    },
    getExamPapers (filter) {
      this.$api.post(this.$global.examApiPath, '/examPaper/search', filter, r => {
        this.courseCnt = r.cntData
        this.pages = Math.ceil(r.cntData / this.$global.paginationOptions.page_num)
        this.list = r.data
      })
    },
    editExamPaper (id) {
      if (id == '') {
        id = 'create'
      }
      this.$router.push({path: '/org/examPaper/'+ id})
    },
    delExamPaper (id) {
      this.$api.post(this.$global.examApiPath, '/examPaper/delete', {id: id}, r => {
        getExamPapers(this.filter)
      })
    },
    examPaperAnswer (id) {
      this.$router.push({path: '/org/examPaperAnswerList/'+ id})
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_paper/answerList.vue